// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    widgetId: string;
    isShellEdit?: boolean;
    productNumbers: string[];
}

interface Props {
    getProductCollectionParameter?: GetProductCollectionApiV2Parameter;
    additionalSort?: (products: ProductModel[]) => ProductModel[];
}

type HandlerType = Handler<Parameter, Props>;

export const LoadProducts: HandlerType = props => {
    props.getProductCollectionParameter = { productNumbers: props.parameter.productNumbers };

    const {
        getProductCollectionParameter,
        dispatch,
        parameter: { widgetId: id },
    } = props;

    props.additionalSort = (products: ProductModel[]) =>
        getProductCollectionParameter.productNumbers
            ?.map(o => products.find(p => p.productNumber === o))
            .filter(o => !!o) as ProductModel[];

    if (!getProductCollectionParameter || !props.parameter.productNumbers) {
        return false;
    }

    dispatch(
        loadProductInfoList({
            getProductCollectionParameter,
            id,
            additionalSort: props.additionalSort,
        }),
    );
};

export const chain = [LoadProducts];

const LoadSheetProducts = createHandlerChainRunner(chain, "LoadSheetProducts");
export default LoadSheetProducts;
